import React from 'react';
import useModal from '../../../../../../hooks/useModal';

import MainInputComponent from '../../components/MainInputComponent';
import ModalContentContainer from './ModalContentContainer';

const MainInputContainer = ({ state, setState }) => {

  const { openModal, ModalPortal, closeModal } = useModal();

  const onChangeHandler = e => {
    const { name, value } = e.target;
    setState(prev => ({...prev, [name]: value}));
  }

  return (
    <div>
        <MainInputComponent 
          state={state}
          onChangeHandler={onChangeHandler}
          openModal={openModal}
        />
        <ModalPortal>
          <ModalContentContainer
            setState={setState} 
            closeModal={closeModal}
          />
        </ModalPortal>
    </div>
  )
};

export default MainInputContainer;